/**
 * Where the app keeps its session in the browser (`web/src/helpers/tokenStorage.ts`).
 *
 * Shared because the public site runs on the same origin and reads them: its
 * header says "Open the app" to someone signed in, and a venue's page asks to
 * serve it with the vendor's own session. The site only ever reads them. Signing
 * in, refreshing and signing out stay the app's, since refreshing from two places
 * would spend a refresh token twice, which the API treats as theft
 * (docs/staying-signed-in.md).
 */
export const ACCESS_TOKEN_STORAGE_KEY = 'app.accessToken'
export const REFRESH_TOKEN_STORAGE_KEY = 'app.refreshToken'
